export const formatPrice = (number: number) => {
  const inputNumber = number < 0 ? 0 : number;
  const unitWords = ['', '만', '억', '조', '경'];
  const splitUnit = 10000;
  const splitCount = unitWords.length;
  const resultArray = [];
  let resultString = '';

  for (let i = 0; i < splitCount; i += 1) {
    let unitResult = (inputNumber % splitUnit ** (i + 1)) / splitUnit ** i;
    unitResult = Math.floor(unitResult);
    if (unitResult > 0) {
      resultArray[i] = unitResult;
    }
  }

  for (let i = 0; i < resultArray.length; i += 1) {
    // eslint-disable-next-line no-continue
    if (!resultArray[i]) continue;

    resultString = `${resultArray[i].toLocaleString() + unitWords[i]} ${resultString}`;
  }

  return resultString.trim();
};
